import qs from 'qs';
import fetchCommonInfo from '@/utils/commonConfig';
// import inputUpBubbleInfo from '@/mock/cgi/v1/receptionConf/webim/inputUpBubbleInfo.js'

export default {
  data() {
    return {
      bubbleConfig: {},
    };
  },
  computed: {
    // 是否有数据
    hasBubble() {
      const { bubbles, robotBubbles, aioUpBubbles } = this.bubbleConfig;
      const hasBubbles = bubbles && bubbles.length;
      const hasAioUpBubbles = !!aioUpBubbles?.menuJson?.content?.menu?.list?.length;
      const hasRobotBubbles = !!robotBubbles?.menuJson?.content?.menu?.list?.length;
      return hasBubbles || hasAioUpBubbles || hasRobotBubbles;
    },
  },
  watch: {
    // 获取到值后再去请求
    reception: {
      handler(newValue, oldValue) {
        const { robotId, extuin } = newValue;
        const { robotId: oldRobotId, extuin: oldExtuin } = oldValue;
        if (robotId !== oldRobotId || extuin !== oldExtuin) {
          this.getBubbleConfig();
        }
      },
      deep: true,
    },
  },
  // mounted() {
  //   this.getBubbleConfig()
  // },

  methods: {
    /**
     * @desc 气泡配置
     */
    async getBubbleConfig() {
      // 获取url 参数
      const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      // 获取配置
      const fields = ['inputUpInfoForCommon'];
      this.reception.robotId && fields.push('inputUpInfoForRobot');
      this.reception.extuin && fields.push('inputUpInfoForHuman');
      const { kfuin, wpaId, visitorid, key } = this.wpaDetail;
      const body = {
        kfuin: params.kfuin || kfuin,
        robotId: this.reception.robotId,
        type: 0,
        visitorId: visitorid,

        wpaId,
        fields,
        key,
      };
      fetchCommonInfo(body, ({ inputUpInfoForHuman = {}, inputUpInfoForCommon = {}, inputUpInfoForRobot = {} }) => {
        // const { inputUpInfoForHuman, inputUpInfoForCommon, inputUpInfoForRobot } = inputUpBubbleInfo
        const bubbles = inputUpInfoForCommon?.data || {};
        const robotBubbles = inputUpInfoForRobot?.data || {};
        const aioUpBubbles = inputUpInfoForHuman?.data || {};
        this.bubbleConfig = {
          bubbles,
          robotBubbles,
          aioUpBubbles,
        };
        let type;

        if (this.bubbleConfig.aioUpBubbles?.menuJson?.content?.menu?.list?.length) {
          type = 'forHuman';
        } else if (bubbles && bubbles.length && bubbles !== 'null') {
          type = 'normal';
        } else if (this.bubbleConfig.robotBubbles?.menuJson?.content?.menu?.list?.length) {
          type = 'robot';
        }
        this.bubbleConfig.type = type;
        console.log('bubbleConfig', this.bubbleConfig);
      });
    },
  },
};
